import { ContractFileGroup } from '../../contracte-programari.interface';

// ── Category icons ────────────────────────────────────────────────────────────

export const ContractDocCategoryIcons: Record<string, string> = {
    'administrativ': 'fa-solid fa-gears',
    'altele': 'fa-solid fa-folder-open',
};

// ── Enums ─────────────────────────────────────────────────────────────────────

export enum OrderMode {
    ASCENDING = 1,
    DESCENDING = -1,
}

export enum ViewMode {
    BY_CATEGORY = 'by_category',
    BY_DATE = 'chronological',
    BY_TAG = 'by_tag',
}

// ── Tag ───────────────────────────────────────────────────────────────────────

export interface DocumentTag {
    id: number;
    name: string;
    color?: string;
}

// ── Metadata ──────────────────────────────────────────────────────────────────

export interface BaseContractDocumentMeta {
    document_nr?: string | null;
    document_date?: string | null;
    observations?: string | null;
}

export interface AdministrativMeta extends BaseContractDocumentMeta {
    registration_nr?: string | null;   // Număr înregistrare intern
    department?: string | null;   // Departament / Serviciu emitent
    responsible_name?: string | null;   // Persoană responsabilă
    deadline?: string | null;   // Termen limită (ISO date string)
}

export interface ContractualMeta extends BaseContractDocumentMeta {
    contract_value?: string | null;  // Valoare contract
    contracting_party?: string | null;  // Parte contractantă
    contract_type?: string | null;  // Tip contract
    signing_date?: string | null;  // Data semnării (ISO date string)
}

export type ContractDocumentMeta = AdministrativMeta | ContractualMeta;

// ── ViewCard ──────────────────────────────────────────────────────────────────

export interface ViewCard {
    label: string;
    icon?: string;
    color?: string;
    fileGroups: ContractFileGroup[];
}